import { IAdvancedFilterConfig, IPrimeTableColumn } from "../interfaces/table-interfaces";
import { IPrimeFilterData } from "../interfaces/filter-interfaces";
import { convertDotsToUnderscores } from "./primeHelpers";
import { Filters } from "..";

export type IAdvancedFiltersOptionsType = "text" | "number" | "dropdown" | "date" | "checkbox" | "none";
export interface IAdvancedFiltersOptions {
    filterLabel: string;
    filterField: string | undefined;
    field: string;
    filterOptionConfig?: {
        appModelPath: string;
        field: string;
    };
    type: IAdvancedFiltersOptionsType;
}

export const generateAdvancedFiltersOptions = (
    advancedFiltersConfig: IAdvancedFilterConfig[],
    t: (arg: string) => string
): IAdvancedFiltersOptions[] => {
    let filterColumns: IAdvancedFiltersOptions[] = [];

    advancedFiltersConfig?.forEach((configObj) => {
        const columns = [...configObj.columns]
            .map((col) => ({ ...col, header: t(col.header) }))
            .sort((a, b) => a.header.localeCompare(b.header));

        const prefixFilterLabel = t(configObj.prefix?.filterLabel || "");
        const prefixFilterField = configObj.prefix?.filterField;

        columns.forEach((col) => {
            if (!col.filterBody) return;

            const filterField = convertDotsToUnderscores(col.filterFieldName ? col.filterFieldName : col.field);

            let baseFilterColumn: IAdvancedFiltersOptions = {
                ...(col.filterOptionConfig && {
                    filterOptionConfig: {
                        appModelPath: `${col.filterOptionConfig.app}.${col.filterOptionConfig.model}`,
                        field: col.filterOptionConfig.field ? col.filterOptionConfig.field : col.field,
                    },
                }),
                type: getFilterOptionType(col),
            } as IAdvancedFiltersOptions;

            if (configObj.prefix) {
                filterColumns.push({
                    ...baseFilterColumn,
                    filterLabel: `[${prefixFilterLabel}]: ${col.header}`,
                    filterField: prefixFilterField ? `${prefixFilterField}.${filterField}` : filterField,
                });
            } else {
                filterColumns.push({ ...baseFilterColumn, filterLabel: col.header, filterField, field: col.field });
            }
        });
    });

    return filterColumns;
};

const getFilterOptionType = (col: IPrimeTableColumn): IAdvancedFiltersOptionsType => {
    if (col?.filterBody) {
        switch (col.filterBody.name) {
            case "MemoFilterTextInput":
            case "text":
            case Filters.text.name:
                return "text";
            case "select":
            case "MemoFilterSelectInput":
            case Filters.select.name:
                return "dropdown";
            case "checkbox":
            case Filters.checkbox.name:
            case "MemoFilterCheckboxInput":
                return "checkbox";
            case "date":
            case "MemoFilterDateRangeInput":
            case Filters.date.name:
                return "date";
            default:
                return "text";
        }
    } else return "none";
};
